import { createSelector } from '@ngrx/store';

import { selectOrderFillFeatureState, State } from '@ruby/modules/order-fill/store';
import * as fromOrderFill from '@ruby/modules/order-fill/store/reducers/order-fill.reducer';
import * as fromOrderFillHeader from '@ruby/shared/inventory-management/order-history-header/store/reducers/order-history-filters.reducer';
import { selectOrderFillFiltersState } from '@ruby/shared/inventory-management/order-history-header/store/selectors/order-history-filters.selectors';

export const selectOrder = createSelector(
  selectOrderFillFeatureState,
  selectOrderFillFiltersState,
  (state: State, filtersState: fromOrderFillHeader.State) => ({
    state: state[fromOrderFill.featureKey],
    loadingLocations: filtersState.loadingLocations,
    loadingPatterns: filtersState.loadingPatterns,
    dateInterval: filtersState.dateInterval
  })
);
